<template>
  <div class="grid grid-cols-12 gap-4">
    <div class="col-span-12">
      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-12 mx-auto mt-2">
          <div class="grid grid-cols-12 gap-4 mx-1">
            <div class="col-span-12">
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"                    id="companyName"
                    
                    
                    :disabled="true"
                    :value="getAddress?.data?.country?.name"
                    required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"                    id="companyName"
                    
                    
                    :disabled="true"
                    :value="getAddress?.data?.region?.name"
                    required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus text-capitalize"                    id="companyName"
                    
                    
                    :disabled="true"
                    :value="getAddress?.data?.district?.name"
                    required>
                </input>
              </div>
            </div>
            <div class="col-span-12">
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus text-capitalize"                    id="companyName"
                    
                    
                    :disabled="true"
                    :value="getAddress?.data?.subcounty?.name"
                    required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"                    id="companyName"
                    
                    
                    :disabled="true"
                    :value="getAddress?.data?.parish?.name"
                    required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus text-capitalize"                    id="companyName"
                    
                    
                    :disabled="true"
                    :value="getAddress?.data?.village?.name"
                    required>
                </input>
              </div>
            </div>
            <div class="col-span-12">
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus text-capitalize"                    id="companyName"
                    
                    
                    :disabled="true"
                    :value="file.street"
                    required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus text-capitalize"                    id="companyName"
                    
                    
                    :disabled="true"
                    :value="file.plot"
                    required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus text-capitalize"                    id="companyName"
                    
                    
                    :disabled="true"
                    :value="file.postalAddress"
                    required>
                </input>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted } from "vue";
import { useSettingsStore } from "@/stores/settings";

const props = defineProps<{ file: any }>();

const settingsStore = useSettingsStore();

const getAddress = computed(() => settingsStore.address);

onMounted(() => {
  settingsStore.fetchAddressByVillageId(props.file.villageId);
});
</script>

